/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Import_Importing_ToastInputs */



/**
* | output |
* | --- |
* | "Importing translation events..." |
*
* @param {Translation_Import_Importing_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_import_importing_toast = /** @type {((inputs?: Translation_Import_Importing_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Import_Importing_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation des événements de traduction...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersetzungsereignisse werden importiert...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione degli eventi di traduzione...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт событий перевода...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importando eventos de traducción...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在导入翻译事件...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("翻訳イベントをインポートしています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुवाद संबंधी घटनाओं को आयात किया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importando eventos de tradução...")
	return /** @type {LocalizedString} */ ("Importing translation events...")
});